import axios from "axios";
import { NetworkCallPayload } from "./networkHandler.types";
import { cWingsServiceBaseURL} from "../config/Api.config";
import { replaceUrlVariables } from "../utils/updateUrlParams";
import AppConstants from "../constants/AppConstants";
import { filterConflictingHeaders, getStoredHeaders } from "utils/storageUtils";
import { COUNTRY_URL_KEYS } from "constants/CommonConstants";
import isEmpty from "lodash/isEmpty";

const networkDefaultSetting = (urlString: string) => {
  axios.defaults.baseURL = urlString ;
  axios.defaults.headers.common["Authorization"] = sessionStorage.getItem("token");
  axios.defaults.headers.common["system-id"] = "CWINGS";
  axios.defaults.headers.common["countryISOCode"] = sessionStorage.getItem(AppConstants.COUNTRY_CODE);
};

const customNetworHandler = async (params: NetworkCallPayload, urlString: string, serviceType?: (typeof COUNTRY_URL_KEYS)[keyof typeof COUNTRY_URL_KEYS] ) => {
  const { url, urlParams, headers, ...restApiOptions } = params;
  let updateUrl = url;
  if (urlParams) {
    updateUrl = replaceUrlVariables(url, urlParams);
  }

  networkDefaultSetting(urlString);
  const requestHeaders = headers || {};
  
  if (serviceType) {
    const storedHeaders = getStoredHeaders(serviceType);
    if (storedHeaders  && !isEmpty(storedHeaders)) {
      const allExistingHeaders = {
        ...axios.defaults.headers.common,
        ...requestHeaders
      };
      const filteredHeaders = filterConflictingHeaders(storedHeaders, allExistingHeaders);
      Object.assign(requestHeaders, filteredHeaders);
    }
  }

  return await axios.request({ 
    url: updateUrl, 
    headers: requestHeaders,
    ...restApiOptions 
  });
};

export default customNetworHandler;
